import { render, staticRenderFns } from "./comercial_identificacion.vue?vue&type=template&id=42e93657&"
import script from "./comercial_identificacion.vue?vue&type=script&lang=js&"
export * from "./comercial_identificacion.vue?vue&type=script&lang=js&"
import style0 from "./comercial_identificacion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('42e93657', component.options)
    } else {
      api.reload('42e93657', component.options)
    }
    module.hot.accept("./comercial_identificacion.vue?vue&type=template&id=42e93657&", function () {
      api.rerender('42e93657', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Map/Details/comercial_identificacion.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/Map/Details/comercial_identificacion.vue
// module id = DOO0
// module chunks = 0